// extracted by mini-css-extract-plugin
export default {"modal":"UserSettingsModal_modal__zo3Jj"};